import { StallActionTypes } from "./constants";

const INIT_STATE = {
    results: [],
    totalRecords: 0,
    vendorDetailsById: null,
    stallDetailsById: null,
    loading: false,
    error: null,
    isStallCreated: false,
    isStallUpdated: false,
    importLoading: false,
    importSuccess: false,
    importErrors: [] as string[],
    importProgress: 0,
};

const Stall = (state = INIT_STATE, action: any) => {
    switch (action.type) {
        case StallActionTypes.API_RESPONSE_SUCCESS:
            switch (action.payload.actionType) {
                case StallActionTypes.GET_STALLS: {
                    const stallData = action.payload.data?.data || action.payload.data;

                    return {
                        ...state,
                        results:
                            stallData?.results ||
                            stallData?.stalls ||
                            stallData ||
                            [],
                        totalRecords:
                            stallData?.totalResults ||
                            stallData?.totalRecords ||
                            stallData?.count ||
                            0,
                        loading: false,
                    };
                }

                case StallActionTypes.GET_STALL_BY_ID:
                    return {
                        ...state,
                        stallDetailsById:
                            action.payload.data?.data || action.payload.data,
                        loading: false,
                    };

                case StallActionTypes.ADD_STALL:
                    return {
                        ...state,
                        isStallCreated: true,
                        loading: false,
                    };

                case StallActionTypes.UPDATE_STALL:
                    return {
                        ...state,
                        isStallUpdated: true,
                        loading: false,
                    };

                case StallActionTypes.DELETE_STALL:
                    return {
                        ...state,
                        loading: false,
                    };

                case StallActionTypes.BULK_IMPORT_STALLS:
                    return {
                        ...state,
                        importLoading: false,
                        importSuccess: true,
                        importProgress: 100,
                        importErrors: [],
                    };
                    
                case '@@stall/BULK_IMPORT_PROGRESS':
                    return {
                        ...state,
                        importProgress: action.payload.progress || 0,
                    };

                default:
                    return { ...state };
            }

        case StallActionTypes.API_RESPONSE_ERROR: {
            if (action.payload.actionType === StallActionTypes.BULK_IMPORT_STALLS) {
                return {
                    ...state,
                    importLoading: false,
                    importSuccess: false,
                    importErrors: Array.isArray(action.payload.error) ? action.payload.error : [action.payload.error || 'An error occurred'],
                };
            }
            return {
                ...state,
                error: action.payload.error,
                loading: false,
            };
        }

        case StallActionTypes.GET_STALLS:
        case StallActionTypes.GET_STALL_BY_ID:
        case StallActionTypes.ADD_STALL:
        case StallActionTypes.UPDATE_STALL:
        case StallActionTypes.DELETE_STALL:
            return {
                ...state,
                loading: true,
                error: null,
                isStallCreated: false,
                isStallUpdated: false,
            };

        case StallActionTypes.RESET:
            return {
                ...state,
                isStallCreated: false,
                isStallUpdated: false,
                stallDetailsById: null,
                error: null,
            };

        case StallActionTypes.BULK_IMPORT_STALLS:
            return {
                ...state,
                importLoading: true,
                importSuccess: false,
                importErrors: [],
                importProgress: 0,
            };

        case StallActionTypes.RESET_IMPORT_STATE:
            return {
                ...state,
                importLoading: false,
                importSuccess: false,
                importErrors: [],
                importProgress: 0,
            };

        default:
            return state;
    }
};

export default Stall;